import React from 'react';

import { getEntityLastActionInfo } from '@utils';
import { format as formatDate } from '@utils/date';
import { CellDescription } from '@atoms';

// TODO: redo the component rendering to be more flexible
const TableDateColumn = ({ entity, label, options }) => {
  const { action, date } = getEntityLastActionInfo(entity, options);
  return (
    <CellDescription label={label || action}>
      <time dateTime={date} title={date}>
        {formatDate(date)}
      </time>
    </CellDescription>
  );
};

export default TableDateColumn;
